import { useState } from "react";
import axiosInstance from "../../../api/axios";
import toast from "../../../shared/toast";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { newCompanySchema } from "../../../validation/newCompanySchema";
import WaitLoading from "../../../shared/WaitLoading";

export default function NewClient() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    companyLocation: "",
    tags: [],
  });

  const [sendingLoading, setSendingLoading] = useState(false);

  const { tags, companyLocation } = formData;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(newCompanySchema),
  });

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    setSendingLoading(true);

    const userData = {
      name: e.companyName,
      tags,
    };
    try {
      const response = await axiosInstance.post(
        `/api-admin/companies/new-company`,
        userData
      );
      toast("success", response.data.message);
      navigate("/companies");

      setFormData({
        companyLocation: "",
        tags: [],
      });
    } catch (error) {
      console.error("Error posting data:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast("error", error.response.data.message);
      } else {
        toast("error", "Szerver hiba");
      }
    } finally {
      setSendingLoading(false);
    }
  };

  const handleTagAddWithButton = () => {
    if (companyLocation.trim() !== "") {
      const newTag = {
        id: new Date().getTime(),
        name: companyLocation,
      };
      setFormData((prevState) => ({
        ...prevState,
        tags: [...prevState.tags, newTag],
        companyLocation: "",
      }));
    }
  };

  const handleTagDelete = (tagId) => {
    setFormData((prevState) => ({
      ...prevState,
      tags: prevState.tags.filter((tag) => tag.id !== tagId),
    }));
  };

  if (sendingLoading) {
    return <WaitLoading />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header card-no-border pb-3">
              <h3>Új cég létrehozása</h3>
            </div>
            <div className="card-body">
              <div className="horizontal-wizard-wrapper">
                <div className="row g-3">
                  <div className="col-12">
                    <div
                      className="tab-content dark-field"
                      id="horizontal-wizard-tabContent"
                    >
                      <div
                        className="tab-pane fade show active"
                        id="wizard-info"
                        role="tabpanel"
                        aria-labelledby="wizard-info-tab"
                      >
                        <form
                          className="row g-3 needs-validation basic-form"
                          onSubmit={handleSubmit(onSubmit)}
                        >
                          <div className="col-xl-4 col-sm-6">
                            <label className="form-label" htmlFor="companyName">
                              Cég<span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={control}
                              name="companyName"
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-control"
                                  id="companyName"
                                  type="text"
                                  placeholder="Cég név megadása"
                                />
                              )}
                            />
                            {errors.companyName && (
                              <p className="text-danger">
                                {errors.companyName.message}
                              </p>
                            )}
                          </div>
                          <div className="row pt-3">
                            <div className="col-xl-4 col-sm-6">
                              <label className="form-label" htmlFor="location">
                                Telephely hozzáadása
                                <span className="text-danger">*</span>
                              </label>
                              <div className="">
                                <input
                                  className="form-control"
                                  id="location"
                                  type="text"
                                  placeholder="Telephely név"
                                  name="companyLocation"
                                  onChange={onChange}
                                  value={companyLocation}
                                />
                                <div className="tag-container mt-2 pt-2">
                                  {tags.map((tag) => (
                                    <span className="d-flex" key={tag.id}>
                                      <span className="badge companyLocText text-dark">
                                        {tag.name}
                                        <MdDelete
                                          style={{
                                            cursor: "pointer",
                                            color: "red",
                                            marginLeft: "5px",
                                            marginTop: "-5px",
                                          }}
                                          onClick={() =>
                                            handleTagDelete(tag.id)
                                          }
                                        />
                                      </span>
                                    </span>
                                  ))}
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-outline-success mt-3"
                                  onClick={handleTagAddWithButton}
                                >
                                  Telephely hozzáadása
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 text-end">
                            <button
                              className="btn btn-primary"
                              disabled={sendingLoading}
                            >
                              Létrehozás
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
